import type { IndexDef, IndexScale } from '@/api/types/readiness'

// ── Scale-aware rendering (Iteration 2 Note 6) ──────────────────────────────
// Card, heatmap cell, drawer, matrix cell and chart each have two renderers
// keyed on `index.scale`. `stages` is reserved (§13) and throws so every switch
// stays exhaustive.

export type ImplementedScale = Exclude<IndexScale, 'stages'>

export function assertScale(index: IndexDef): ImplementedScale {
  const scale = index.scale ?? 'levels'
  switch (scale) {
    case 'levels':
    case 'score_0_10':
      return scale
    case 'stages':
      throw new Error(`Index ${index.id}: scale "stages" is reserved and not implemented (Iteration 2 §11.2, §13).`)
  }
}

export const isScoreScale = (index: IndexDef) => assertScale(index) === 'score_0_10'
export const isPreliminary = (index: IndexDef) => index.status === 'preliminary'

// Suggestion cap for the score scale: tier 2 of m (§11.3).
export const SCORE_SUGGESTION_TIER_CAP = 2

export const fmtScore = (s: number | null | undefined) => (s == null ? '—' : s.toFixed(1))
